/* eslint-disable */
import { io } from 'socket.io-client'

import Vue from 'vue'
import store from '@/store'
import Totem from '@/services/Totem'
import StreamHealth from '@/plugins/StreamHealth'
import router from '@/router/index'

const socket = io(process.env.VUE_APP_LISTEN_API_URL || '', {
  reconnectionDelayMax: 10000,
  autoConnect: false,
  reconnection: true,
  transports: ['websocket']
})

socket.on('connect', () => {
	const organization = store.state.widget.data.organization
	const widget = store.state.widget.data

  if (!organization.id || !widget.uuid) {
    return false
  }

	socket.emit('join_room', { model: 'organizations', id: organization.id })
	socket.emit('join_room', { model: 'widget', id: widget.uuid })

  const storage:any = store.state.storage
  const sessionId = storage.room ? storage.room.session.id : null

	const totemCode = store.state.widget.code
	if (totemCode) {
    socketEvents.registerDevice(totemCode);
	}

  if (sessionId) {
    socket.emit('join_room', { model: 'sessions', id: sessionId })
  }

  socketEvents.findOrganizationUsersAvailable({ organization: { id: organization.id } })
})

socket.on('disconnect', (reason) => {
  console.log('Disconnected. Attempting to reconnect...')
  const totemCode = store.state.widget.code
	if (totemCode) {
    setTimeout(() => {
      socket.connect()
    }, 5000)
  }
})

socket.on('widget_queue_info', (arg) => {
  const storage:any = store.state.storage
  const sessionId = storage.room ? storage.room.session.id : null

  if (sessionId) {
    const queue = arg.queue
    const index = queue.findIndex((session: any) => session.id === sessionId)

    if (index >= 0) {
      store.state.queue.position = (index + 1)
    }
  }
})

socket.on('widget_app_pong', (arg) => {
  const widgetService = Vue.prototype.$organization
  const configInitCall = widgetService.configInitCall().data

  const data = {
    platform: {
      to: arg.platform.from,
      from: 'widget_app'
    },
    session: arg.session,
    widget: {
      configInitCall
    }
  }

  try {
    const storage:any = store.state.storage
    const sessionId = storage.room ? storage.room.session.id : null
    const widgetState = storage.state

    if (sessionId && widgetState && (widgetState.id === 3 || widgetState.id === 4)) {
      if (store.state.channelIsSet && data.session?.channel && data.session.channel !== store.state.channel) {
        Vue.prototype.$widget.reTry()
      }
      socket.emit('ping', data)

      const code = new Date().getTime().toString()
      store.state.ping.code = <any> code

      socket.emit('os_media_devices_permissions', {
        session: storage.room.session,
        permissions: store.state.widget.osMediaDevicesPermissions
      })
    }
  } catch (error) {
    // code
  }
})

const goToRoom = (session: any) => {
  const storage = Vue.prototype.$storage

  storage.setStorageRoom(session)
  storage.setState(4)

  router.replace({ path: '/call' })
}

const joinCall = async (session: any) => {
  const totemCode = store.state.widget.code

  if (!totemCode) {
    return false
  }

  const params = {
    totemId: totemCode,
    status: 'onCall'
  }

  await Totem.setTotemStatus(params)

  goToRoom(session)
  return Totem.setWidgetUuidSession(session.id)
}

socket.on('join_totem_call', (arg) => {
  const storage:any = store.state.storage
  const widgetState = storage.state

  if (widgetState && widgetState.id === 1) {
    const sessionId = Number(arg.session_id)
    joinCall({
      id: sessionId,
      // session_id: arg.tokbox.tokbox_id,
      // token: arg.tokbox.token
    })
  }
})

socket.on('organization_cammers', (arg) => {
  const cammers = arg.cammers.filter((cammer:any) => cammer.online && !cammer.busy)
  store.commit('setCammersAvailable', cammers)
})

socket.on('health_pong', (arg) => {
  StreamHealth.saveLatencies()
})

socket.on('removed_from_queue', (arg) => {
  store.state.queue.data = { status: arg.status }
  store.state.queue.isAlive = false
})

socket.on('queue_status', (arg) => {
  const queueItem = arg

  store.state.queue.data = queueItem
  store.state.queue.isAlive = queueItem && (queueItem.status === 1 || queueItem.status === 2 || queueItem.status === 3)
})

socket.on('device-added', () => {
  const mediaAccess: any = store.state.mediaAccess

  if (mediaAccess?.video === true && mediaAccess?.audio === true) {
    socketEvents.updateDeviceMetadata({ mediaAccess });
    socketEvents.joinTotemRoom();
    socketEvents.updateDeviceState('available');
  } else {
    socketEvents.updateDeviceState('unavailable');
  }
})

socket.on('device-removed', (arg) => {
  // console.log('Device removed:', arg)
})

socket.on('device-updated', (arg) => {
  // console.log('Device updated:', arg)
})

socket.on('device-state-updated', (arg) => {
  // console.log('Device state updated:', arg)
})

class SocketEvents {
  // connectListen () {
  //   if (!socket.connected) {
  //     socket.connect()
  //   }
  // }

  async connectListen(): Promise<void> {
    if (socket.connected) {
      return;
    }

    return new Promise<void>((resolve, reject) => {
      socket.once('connect', resolve);
      socket.once('connect_error', reject);
      socket.connect();
    });
  }

  joinTotemRoom () {
    const totemCode = store.state.widget.code;
    const widget = store.state.widget.data;

    if (totemCode && widget?.uuid) {
      socket.emit('join_room', { model: 'totem', id: `${totemCode}-${widget.uuid}`});
    }
  }

  leaveTotemRoom () {
    const totemCode = store.state.widget.code;
    const widget = store.state.widget.data;

    if (totemCode && widget?.uuid) {
      socket.emit('leave_room', { roomName: `totem-${totemCode}-${widget.uuid}` });
    }
  }

  disconnectListen () {
    if (socket.connected) {
      socket.disconnect()
    }
  }

  joinToSessionRoom (sessionId:number) {
    socket.emit('join_room', { model: 'sessions', id: sessionId });
    socket.emit('join_room', { model: 'widget-call', id: sessionId });
  }

  findOrganizationUsersAvailable (data:any) {
    socket.emit('users_available', data)
  }

  findOrganizationQueueInfo (organizationId:number) {
    socket.emit('queue_info', organizationId)
  }

  reportProblem (data:any) {
    socket.emit('report_problem', data)
  }

  disconnectSession (data:any) {
    socket.emit('disconnect_session', data)
  }

  scheduledEvents (data:any) {
    socket.emit('scheduled_events', data)
  }

  healthPing () {
    const storage:any = store.state.storage
    const widgetState = storage.state

    if (widgetState.id === 4) {
      socket.emit('health_ping')
    }
  }

  storageLatency (data:any) {
    socket.emit('storage_latency', data)
  }

  sendSignalLatency (data:any) {
    const storage:any = store.state.storage
    const payload = {
      sessionId : storage.room ? storage.room.session.id : null,
      value: data
    }
    socket.emit('send_latency_widget', payload)
  }

  queueStatusPing () {
    const storage:any = store.state.storage
    const sessionId = storage.room ? storage.room.session.id : null

    socket.emit('check_queue_status_ping', { id: sessionId })
  }

  registerDevice (deviceId: any) {
    const organization = store.state.widget.data.organization
	  const widget = store.state.widget.data

    if (!organization.uuid || !widget.uuid) {
      return false
    }

    socket.emit('add-device', {
      state: 'registered',
      deviceId: deviceId,
      widgetUuid: widget.uuid,
      organizationUuid: organization.uuid,
      metadata: {}
    });
  }

  updateDeviceState(state: string) {
    if (socket.connected) {
      socket.emit('update-device-state', { state });
    }
  }

  updateDeviceMetadata(metadata: any) {
    if (socket.connected) {
      socket.emit('update-device', { metadata });
    }
  }
}

const socketEvents = new SocketEvents()

Vue.prototype.$socketEvents = socketEvents
Vue.prototype.$listenSocket = socket
